// "Export Issues" button - an `export` job (kind `preflight_issues`, see
// preflight_issues_export.py) builds the xlsx workbook in S3; the finished
// job carries a presigned download_url (with the filename in its
// Content-Disposition), downloaded via an anchor click.

import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { apiErrorDetail, runExport, useWizardJob } from '../jobs';
import errorMessage from '../../../helpers/errorMessage';

const ExportIssuesButton = ({ reportingId, label = 'Export Issues' }) => {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);
  const { runJob, busy } = useWizardJob();

  const handleClick = async () => {
    if (!reportingId) return;
    setDownloading(true);
    setError(null);
    try {
      await runExport(runJob, reportingId, { kind: 'preflight_issues' });
    } catch (err) {
      if (err.cancelled) return;
      console.error('[ExportIssuesButton] export error:', err.detail || errorMessage(err));
      setError(apiErrorDetail(err, 'Failed to export issues.'));
    }
    setDownloading(false);
  };

  return (
    <span>
      <Button
        label={label}
        icon="pi pi-download"
        className="p-button-outlined"
        onClick={handleClick}
        disabled={!reportingId || downloading || busy}
        loading={downloading}
      />
      {error && <span className="ex-inline-error cr-inline-error-inline">{error}</span>}
    </span>
  );
};

export default ExportIssuesButton;
